import { useLocation } from 'react-router-dom';
import { FloatingKnowledgeButton } from './FloatingKnowledgeButton';

// Routes where the floating knowledge button should appear.
// Expanded in v2.1.0 from just "focus screens" (creation flows) to all
// authenticated user work routes. Keep auth/onboarding routes OUT.
const KNOWLEDGE_ENABLED_ROUTES = [
  // Dashboard + blog workflows
  '/dashboard',
  '/my-blogs',
  '/text-import',
  '/idea-select',
  '/idea-check',
  '/idea-reject',
  '/idea-custom',
  '/idea-generate',
  '/article-generate',
  '/article-edit',
  '/title-generate',
  '/select-title',
  '/intro-generate',
  '/select-intro',
  '/image-generate',
  '/select-image',
  '/blog-preview',
  '/blog/edit',

  // Campaigns
  '/campaigns',
  '/campaign/',

  // Mailinglist
  '/mailinglist',

  // Social media
  '/social-media',

  // Activity + success
  '/activiteit',
  '/success',
];

// Explicit blocklist — routes that match KNOWLEDGE_ENABLED_ROUTES prefixes
// but should NOT show the button (e.g. onboarding wizard at /dashboard/...).
const KNOWLEDGE_DISABLED_ROUTES = [
  '/dashboard/onboarding',
];

export function ConditionalFloatingButton() {
  const location = useLocation();
  const path = location.pathname;

  const isBlocked = KNOWLEDGE_DISABLED_ROUTES.some((route) =>
    path.startsWith(route),
  );
  if (isBlocked) return null;

  const isEnabled = KNOWLEDGE_ENABLED_ROUTES.some((route) =>
    path.startsWith(route),
  );
  if (!isEnabled) return null;

  return <FloatingKnowledgeButton />;
}
